import React, { useEffect, useState } from "react";
import { getDeviceType, reportApkPure, reportGotoHuaWei, reportGotoOppo, reportGotoVivo } from "../utils/tools";
import androidIcon from "@/assets/imgs/home/modal/androidIcon.png";
import driectIcon from "@/assets/imgs/home/modal/driectIcon.png";
import modal1Bg from "@/assets/imgs/home/modal/modal1Bg.png";
import HW from "@/assets/imgs/home/modal/HW.png";
import OP from "@/assets/imgs/home/modal/OP.png";
import VV from "@/assets/imgs/home/modal/VV.png";
import "./downloadComponent.less";
import { getDownloadUrl } from "../utils/common";
import { 
  reportShowGuideModal,
  reportCancelGuideModal,
  reportDirectConfirm,
  reportDownloadModal,
  reportDownloadChannelModal,
  reportChooseDirect,
  getAppMarketUrlByDeviceType,
  reportGotoApkPure,
 } from "../utils/tools";
 import { enquireScreen } from "enquire-js";



const DownloadComponent = ({cancelModal,isMobile}) => {
  
  const [showModal, setShowModal] = useState(false);
  const [showChannel,setShowChannel] = useState(false);

 
  const detectMobile = (current) =>{
    if (current !== undefined) return current;
    let result = false;
    enquireScreen((b) => {
      result = b;
    });
    return result;
  }

  isMobile =  detectMobile(isMobile);

  const cancel =()=>{
    setShowModal(false);
    cancelModal(false);
  }

  useEffect(() => {
    console.log('getDeviceType',getDeviceType());
    let deviceType = !!getDeviceType() ? getDeviceType() : "OTHER";
    let marketUrl = getAppMarketUrlByDeviceType(deviceType);
    console.log(`download modal start ：${deviceType}`);
    if (deviceType) {
      // 华为 VIVO OPPO 直接跳出应用商店
      deviceType = deviceType.toUpperCase();
      if (deviceType == "HUAWEI") {
        // 上报跳转huawei商店
        // 直接打开应用商店
        reportGotoHuaWei();
        window.location.href = marketUrl;
        cancel();
        return;
      } else if (deviceType == "VIVO") {
        // 上报跳转vivo商店
        reportGotoVivo();
        window.location.href = marketUrl;
        cancel();
        return;
      } else if (deviceType == "OPPO") {
        // 上报跳转oppo商店
        reportGotoOppo();
        window.location.href = marketUrl;
        cancel();
        return;
      } else if(deviceType == 'K' || deviceType =='OTHER'){
        // K 或者 OTHER
        setShowChannel(true);
        setShowModal(true);
        return;
      }
      else{
        // 弹窗1 apk下载或者直接下载
        setShowChannel(false);
        setShowModal(true);
      }
    } else {
      // 弹窗1 apk下载 
      setShowChannel(false);
      setShowModal(true);
    }
  }, []);

  return <div>{showModal && 
  <Modal1  cancelModal={cancel} 
  showChannel={showChannel}
  isMobile={isMobile}
  />}</div>;
};

export default DownloadComponent;

const Modal1 = ({cancelModal, showChannel,isMobile}) => {
  const apkPureUrl =
    "https://apkpure.com/okpeso-safe-online-loan-app/tech.codeblock.okpeso";
  
  const [showGuideModal, setShowGuideModal] = useState(false);

  const apkPureClick = () => {
    // TODO 上报事件
    reportGotoApkPure()
    window.open(apkPureUrl, '_blank');
    cancelModal(false);
  };

  const directClick = () => {
    // 上报事件直接下载事件
    reportChooseDirect();
    // 显示指引弹窗
    setShowGuideModal(true);
  };

  const cancel = (cancelTopModal)=>{
    if(cancelTopModal){
      cancelModal();
    }
    setShowGuideModal(false);
  }


  const huaweiClick= ()=>{
    // 上报华为渠道事件
    let url = getAppMarketUrlByDeviceType('HUAWEI');
    if(!url){
      return;
    }
    reportGotoHuaWei();
    window.open(url, "_blank");
    cancel(true);

    
  }
  const vivoClick= ()=>{
    // 上报vivo渠道事件
    let url = getAppMarketUrlByDeviceType('VIVO');
    if(!url){
      return;
    }
    reportGotoVivo();
    window.open(url, "_blank");
    cancel(true);
  }

  const oppoClick = () =>{
    // 上报oppo 渠道事件
    let url = getAppMarketUrlByDeviceType('OPPO');
    if(!url){
      return;
    }
    reportGotoOppo();
    window.open(url, "_blank");
    cancel(true);
  }

  useEffect(() => {
    console.log("modal Start");
    // 上报事件
    if(showChannel){
        reportDownloadChannelModal();
    }else{
        reportDownloadModal();
    }

  }, []);
  return (
    <div className="modalbg">
      <div className={isMobile ? "modalContainerMobile" :"modalContainer"}>
        {showChannel ? (
          <div className="titleContainer">
            <div className="title">Select Download App Store</div>
            <div className="desc">
              Your device couldn’t be matched to an app store automatically.
              <br />
              Please select a download channel manually:
            </div>
          </div>
        ) : (
          <div className="titleContainer">
            <div className="title">How would you like to download?</div>
            <div className="desc">Don’t see your device. Download via:</div>
          </div>
        )}
        {/* <div className="titleContainer">
          <div className="title">How would you like to download?</div>
          <div className="desc">Don’t see your device. Download via:</div>
        </div> */}
        <div className="content">
          {showChannel ? <><div className="channelButton">
            <button className="channeItemlSelection" onClick={huaweiClick}>
              <img src={HW} alt="HW" />
              <div>HUAWEI</div>
            </button>
            <button className="channeItemlSelection" onClick={vivoClick}>
              <img src={VV} alt="VV" />
              <div>VIVO</div>
            </button>
            <button className="channeItemlSelection" onClick={oppoClick}>
              <img src={OP} alt="OP" />
              <div>OPPO</div>
            </button>
          </div>
          <div className="dbDesc">Don’t see your device. Download via:</div></> : null}
          <div className="defaultButton">
            <button className="defaultItemlSelection" onClick={apkPureClick}>
              <img src={androidIcon} alt="APKPure" />
              <div>APKPure</div>
            </button>
            <button className="defaultItemlSelection" onClick={directClick}>
              <img src={driectIcon} alt="Direct" />
              <div>Direct Download​​ (APK)</div>
            </button>
          </div>
        </div>
      </div>
      {showGuideModal && (
        <GuideModal
        cancel={cancel}
          isMobile={isMobile}
        />
      )}
    </div>
  );
};

const GuideModal = ({cancel,isMobile}) => {
  const [directUrl, setDirectUrl] = useState('');
  useEffect(()=>{
    const fetchData = async () => {
      console.log("window.location.origin: ", window.location);
      try {
        const url = await getDownloadUrl();
        console.log("Download URL: ", url);
        setDirectUrl(url)
      } catch (error) {
        console.error("Error fetching download URL:", error);
      }
    };
    fetchData(); 
    // 上报弹窗打开事件
    reportShowGuideModal();
  },[])

  const goBack = ()=>{
    reportCancelGuideModal();
    cancel(false);
  }

  const confirm =() =>{
    reportDirectConfirm();
    window.open(directUrl, '_blank')
    cancel(true);
  }
  return (
    <div className="modalbg">
      <div className={isMobile ? "guideContainerMobile" :"guideContainer"}>
        <div className="gmTitleContainer">
          <div className="title">Manual Installation Guide</div>
          <div className="desc">
            The system prompt is part of Android’s normal security mechanism.
            <br/>Please proceed with confidence.
          </div>
        </div>

        <div className="gmContentContainer">
          <div className="title">Installation Steps:</div>
          <div className="desc">
            <span>1</span>.After clicking “Download APK”, the system will prompt you to save
            the file
          </div>
          <div className="desc">
          <span>2</span>.Open “File Manager” and locate the downloaded APK file
          </div>
          <div className="desc">
          <span>3</span>.If you see “Prohibited from installing unknown apps” during
            installation: <br/>Go to: <br/>Settings → Security/Privacy → Special App
            Permissions → Install Unknown Apps​​ <br/>Allow installation permissions
            from “Browser/File Manager
          </div>
          <div className="desc"><span>4</span>.Return and complete the installation</div>
          <div className="buttonContainer">
            <button className="return" onClick={goBack}>Return to Select App Store</button>
            <button className="confirm" onClick={confirm}>
              I understand, continue to download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
